import React, { useCallback, useContext, useEffect, useState } from 'react'
import { axiosInstanceMain } from '../../../utils/axiosGlobalUtils'
import { useNavigate } from 'react-router'
import SnackBarUtils from '../../../utils/SnackBarUtils'
import AlertDialog from '../../Common/Dialog'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  Typography,
  IconButton,
  Box
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import HistorialCards from '../HistorialCards'
import { notificarSobreEstafador } from '../../../pages/AbmLocalPage/services/locales.service'
import ConfirmDialog from '../../../pages/Products/components/ConfirmDialog'
import { styled } from '@mui/material'
import { TenantsContext } from '../../../context/tenants.context'
import ObservacionPausar from './DialogObservacionPausar'
import DictionaryItem from '../../../dto/DictionaryDTO'
import { getTiposCuenta } from '../services/admin.local.services'
import { CaracteristicasId, Config, MedioDeContactoList } from '../../../pages/AbmLocalPage/types'
import { FaqDTO, HorarioDTO } from '../../../dto/LocalDTO'
import { Info } from '../../../pages/AdminLocalPage'
import NotificacionPush from '../AdminLocalPush/notificacionPush'

export interface HistorialDTO {
  id: string
  local: {
    idTenant: number
    idLocal: number
    nombreLocal: string
    medioDeContactoList: MedioDeContactoList[]
    direccion: string
    idGaleria: number
    nombreGaleria: string
    galeriaEstructura: any
    idUsuario: number
    latitud: number
    longitud: number
    descripcion: string
    horarios: HorarioDTO[]
    caracteristicasList: CaracteristicasId[]
    caracteristicasOcultasList: CaracteristicasId[]
    faq: FaqDTO[]
    compraMinimaParaEnvio: string
    shareLink: string
    logo: string
    virtual: boolean
    verificado: boolean
    idCuentaTipo: number
    idTemplateSinDestacarMap: number
    idTemplateDestacadoMap: number
    config: Config[]
    tokenIntegracion: string
    aprobarProductosAuto: boolean
    scoring: number
    status: number
    statusString: string
    observacionesEstado: string
    importante: boolean
    caracteristicasVisiblesYOcultas: any[]
    email: string
    telefono: string
    statusFlags: string
    emailConDescripcionListString: string
    telefonoConDescripcionListString: string
    whatsappConDescripcionListString: string
    whatsappList: any[]
    caracteristicasString: string
    horariosString: string
    numLocalLegacy: string
  }
  timestamp: string
  usuarioId: string
  evento: string
  borrado: boolean
}

const StatusRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '6px',
  margin: '0px 15px',
  [theme.breakpoints.down('sm')]: {
    margin: '8px 0px 0px'
  }
}))

const ButtonsRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  margin: '10px 15px 0',
  gap: '10px',
  [theme.breakpoints.down('sm')]: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    margin: '10px 0px 0',
    gap: '8px',
    '& button': {
      width: '100%',
      margin: 0
    }
  }
}))

const AdminLocalState: React.FC<any> = (props: any) => {
  const navigate = useNavigate()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [historialOpen, setHistorialOpen] = useState(false)
  const [historial, setHistorial] = useState<HistorialDTO[]>([])
  const [loadingHistorial, setLoadingHistorial] = useState(false)
  const [openObsPausar, setOpenObsPausar] = useState<boolean>(false)
  const [accountTypes, setAccountTypes] = useState<DictionaryItem[]>([])
  const [confirmDialog, setConfirmDialog] = useState<any>({
    open: false,
    text: {
      title: '',
      body: '',
      leftButton: 'Cancelar',
      rightButton: 'Confirmar',
      colorButtonConfirm: 'primary'
    },
    action: async () => {}
  })
  const theme = useTheme()
  const { tenant } = useContext(TenantsContext)
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  useEffect(() => {
    getTiposCuenta(tenant)
      .then((result) => {
        setAccountTypes(result.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [tenant])

  const handleNotificacionEstafador = useCallback(() => {
    const rangoDias = props.premise?.config.find((c: any) => c.name === 'notificacion_local_sospechoso_dias')?.value
    if (props.premise?.codLocal)
      setConfirmDialog({
        open: true,
        text: {
          title: '¿Deseás notificar sobre un posible estafador?',
          body: `Se le enviará un mensaje a todo comprador que haya contactado al local en lo últimos ${
            rangoDias ? rangoDias : ''
          } días. `,
          leftButton: 'Cancelar',
          rightButton: 'Confirmar',
          colorButtonConfirm: 'error'
        },
        action: async () => {
          await notificarSobreEstafador(props.premise?.codLocal, tenant)
            .then((response) => SnackBarUtils.success(response.data.data))
            .catch(() => console.log())
          clearConfirmDialog()
        },
        close: () => clearConfirmDialog()
      })
  }, [props.premise])

  const clearConfirmDialog = () => {
    setConfirmDialog((confirmDialog: any) => ({
      ...confirmDialog,
      open: false
    }))
  }

  const getLocal = (id: number) => {
    axiosInstanceMain
      .get(`admin/${tenant.path}/locales/` + id)
      .then((result) => {
        const data = result.data.data
        props.setPremise(data)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    props.setPremise(props.premise)
  }, [props.premise])

  const changeLocalStatus = async () => {
    await getLocal(props.premise?.codLocal)
    SnackBarUtils.success('El local ha sido actualizado.')
  }

  const approve = () => {
    axiosInstanceMain
      .post(`/admin/${tenant.path}/locales/${props.premise?.codLocal}/aprobar`)
      .then((result) => {
        changeLocalStatus()
      })
      .catch((error) => {
        console.log(error)
      })
  }
  const reject = () => {
    axiosInstanceMain
      .post(`/admin/${tenant.path}/locales/${props.premise?.codLocal}/rechazar`)
      .then((result) => {
        changeLocalStatus()
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const unpause = () => {
    axiosInstanceMain
      .post(`/admin/${tenant.path}/locales/${props.premise?.codLocal}/despausar`)
      .then((result) => {
        changeLocalStatus()
      })
      .catch((error) => {
        console.log(error)
      })
  }
  const deletePremise = () => {
    axiosInstanceMain
      .delete(`/admin/${tenant.path}/locales/${props.premise?.codLocal}`)
      .then((result) => {
        SnackBarUtils.success('El local ha sido eliminado.')
        navigate('/abm-locales')
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handlePausar = () => {
    setOpenObsPausar(true)
  }

  const getHistorial = () => {
    setLoadingHistorial(true)
    axiosInstanceMain
      .get(`/admin/${tenant.path}/locales/${props.premise?.codLocal}/historialNuevo`)
      .then((result) => {
        setHistorial(result.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoadingHistorial(false)
      })
  }

  const handleHistorialClick = () => {
    setHistorialOpen(true)
    getHistorial()
  }

  return (
    <>
      <StatusRow>
        <Info className="premise-info-child">Estado:</Info>
        <Info className="premise-info-child">
          {props.premise?.statusFlags === 'A'
            ? 'Cuenta activa'
            : props.premise?.statusFlags === 'R'
              ? 'Cuenta rechazada'
              : 'Cuenta inactiva'}
        </Info>
      </StatusRow>
      <ButtonsRow>
        <button
          className={
            props.premise?.statusFlags === 'A'
              ? 'btn btn-light admin-local-btn premise-info-child'
              : 'btn btn-success admin-local-btn premise-info-child'
          }
          onClick={() => (props.premise?.statusFlags === 'A' ? handlePausar() : approve())}
        >
          {props.premise?.statusFlags === 'A' ? 'Pausar' : 'Aprobar'}
        </button>
        <button
          style={props.premise?.statusFlags === 'A' ? { display: 'none' } : {}}
          onClick={unpause}
          className={'btn btn-success admin-local-btn premise-info-child'}
        >
          Despausar
        </button>
        <button
          style={props.premise?.statusFlags === 'R' ? { display: 'none' } : {}}
          onClick={reject}
          className="btn btn-danger admin-local-btn premise-info-child"
        >
          Rechazar
        </button>
        <button onClick={() => setDialogOpen(true)} className="btn btn-danger admin-local-btn premise-info-child">
          Eliminar
        </button>
        <button onClick={handleHistorialClick} className="btn btn-secondary admin-local-btn premise-info-child">
          Historial
        </button>
      </ButtonsRow>
      {props.premise?.observacionesEstado && (
        <Typography style={{ marginLeft: '1rem', fontWeight: 'bold' }}>{props.premise?.observacionesEstado}</Typography>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <button
          style={{ margin: '1rem' }}
          className="btn btn-primary admin-local-btn premise-info-child"
          onClick={() => handleNotificacionEstafador()}
        >
          {isMobile ? 'Notif. sobre un estafador' : 'Notif. compradores sobre un estafador'}
        </button>
        <NotificacionPush premise={props.premise} />
      </Box>
      <AlertDialog
        title="¿Deseas eliminar este local?"
        content="Esta acción no se puede deshacer."
        onConfirm={deletePremise}
        agreeText="Eliminar"
        agreeColor="error"
        disagreeText="Cancelar"
        onCancel={() => setDialogOpen(false)}
        open={dialogOpen}
      />

      <Dialog
        open={historialOpen}
        fullWidth
        PaperProps={{
          style: {
            width: '100%',
            overflowX: 'hidden',
            ...(isMobile && { marginLeft: -20, marginBottom: 4 })
          }
        }}
      >
        <DialogTitle>Historial</DialogTitle>
        <DialogContent>
          <HistorialCards data={historial} loadingHistorial={loadingHistorial} tiposCuenta={accountTypes} />
        </DialogContent>
        <DialogActions>
          <IconButton
            edge="end"
            onClick={() => setHistorialOpen(false)}
            sx={{
              position: 'absolute',
              top: '0',
              right: '0',
              paddingRight: '16px'
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <ConfirmDialog {...confirmDialog} />
      {props.premise && (
        <ObservacionPausar
          open={openObsPausar}
          setOpen={setOpenObsPausar}
          premise={props.premise}
          changeLocalStatus={changeLocalStatus}
          isAdmin={props.isAdmin}
          updateLocal={getLocal}
        />
      )}
    </>
  )
}

export default AdminLocalState
